var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_padding marginB"},[_c('div',{staticClass:"news-top"}),_vm._m(0),_c('editor')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title marginT"},[_c('span',{staticClass:"font30 fontBold"},[_vm._v("공지사항 글쓰기")])])
}]

export { render, staticRenderFns }